module.exports = __webpack_public_path__ + "img/jinny.907609a6.png";